import styles from "../../../styles/Participant-Employment.module.css"
import { groupTable, groupBy } from "../Utils/Utils"
import ViewHeader from "../Utils/ViewHeader"

const FollowAlongSupportView = ({
  followAlongSupport,
  loading,
  closeForm,
  viewMode,
}) => {
  const followDic = [
    {
      label: "Provider(s) of support",
      value: followAlongSupport?.providerOfSupport,
      type: "string",
      group: 1,
    },
    {
      label: "Type of follow-along support",
      value: followAlongSupport?.supportType ?? "",
      type: "string",
      group: 2,
    },
    {
      label: "Support area",
      value: followAlongSupport?.area,
      type: "html",
      group: 3,
    },
    {
      label: "Support status",
      value: followAlongSupport?.status === 0 ? "Active" : "Inactive",
      type: "string",
      group: 2,
    },
  ]
  const basicInfo1 = groupBy(followDic, "group")
  return (
    <div className={styles.rounded_wrapper}>
      <ViewHeader
        viewMode={viewMode}
        closeViewMode={closeForm}
        title={"Follow along support "}
      />
      {groupTable(basicInfo1)}
    </div>
  )
}
export default FollowAlongSupportView
